import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import classes from './FieldGroup.module.scss';

export default function FieldGroup({ children, className, ...rest }: BoxProps) {
  return (
    <Box className={clsx(classes.root, className)} {...rest}>
      {children}
    </Box>
  );
}
